// VentasRoutesXL - Sprint 44 Fase 3 Vista 4.
// Reemplaza modules/ventas/routes.jsx. Rutas preservadas:
// /ventas (index), /ventas/nueva, /ventas/:id.
// La lista ya existia como VentasListXL (Sprint 44 Parte 2 piloto).
import { Routes, Route } from 'react-router-dom';
import VentasListXL from './VentasListXL';
import VentaFormXL from './VentaFormXL';

export default function VentasRoutesXL() {
  return (
    <Routes>
      <Route index element={<VentasListXL />} />
      <Route path="nueva" element={<VentaFormXL />} />
      <Route path=":id" element={<VentaFormXL />} />
    </Routes>
  );
}
